<template>
  <header class="hdr">
    <a href="#top" class="logo">
      <span class="word">NEXXT&nbsp;<span class="thin">GEN</span></span>
    </a>
    <button class="menu-btn" @click="open = true" aria-label="Open menu">
      <span class="lines"><i></i><i></i></span>
      <span class="mtext">MENU</span>
    </button>

    <transition name="scrim">
      <div v-if="open" class="scrim" @click="open = false"></div>
    </transition>

    <transition name="over">
      <div v-if="open" class="overlay">
        <button class="close" @click="open = false">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path d="M5 5 L19 19 M19 5 L5 19" stroke="currentColor" stroke-width="2" fill="none"/>
          </svg>
          CLOSE
        </button>
        <nav class="over-nav">
          <a v-for="l in links" :key="l.label" :href="l.href" @click="open = false">
            {{ l.label }}<sup v-if="l.count">{{ l.count }}</sup>
          </a>
        </nav>
        <div class="over-foot mono">
          <span>Sahakarnagar · Bengaluru</span>
          <a href="tel:+919740639892">+91 97406 39892</a>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      open: false,
      links: [
        { label: 'Home', href: '#top' },
        { label: 'Services', href: '#solutions' },
        { label: 'About', href: '#about' },
        { label: 'Reviews', href: '#reviews' },
        { label: 'Contact', href: '#contact' }
      ]
    }
  }
}
</script>

<style scoped>
.hdr {
  position: fixed; top: 0; left: 0; right: 0; z-index: 90;
  display: flex; align-items: center; justify-content: space-between;
  padding: 26px clamp(20px, 4vw, 54px);
}
.logo {
  font-family: var(--font-display); font-weight: 700; font-size: 22px;
  color: var(--white); text-decoration: none;
  display: inline-flex; align-items: center;
  /* dark capsule with white text, matching the MENU pill */
  background: var(--ink); padding: 11px 20px; border-radius: 999px;
}
.word {
  display: inline-flex; align-items: baseline;
  letter-spacing: -1px; line-height: 1;
  transition: letter-spacing 0.5s var(--ease);
}
.logo:hover .word { letter-spacing: 0.5px; }
.thin { font-weight: 300; color: var(--white); opacity: 0.6; letter-spacing: 0.5px; }
.menu-btn {
  display: inline-flex; align-items: center; gap: 12px;
  padding: 11px 20px 11px 16px;
  background: var(--ink); cursor: pointer;
  border: 1.5px solid var(--ink); border-radius: 999px;
  font-family: var(--font-mono); font-size: 13px; letter-spacing: 2px; color: var(--white);
  transition: background 0.35s var(--ease), border-color 0.35s var(--ease), color 0.35s var(--ease);
}
.menu-btn:hover { background: var(--ink-soft); border-color: var(--ink-soft); }
.lines {
  display: inline-flex; flex-direction: column; align-items: flex-end; gap: 5px;
  width: 22px;
}
.lines i {
  height: 2px; background: currentColor; display: block; border-radius: 2px;
  transition: width 0.35s var(--ease), transform 0.35s var(--ease);
}
.lines i:first-child { width: 22px; }
.lines i:last-child { width: 14px; }
.menu-btn:hover .lines i:last-child { width: 22px; }
.mtext { line-height: 1; }

.scrim {
  position: fixed; inset: 0; z-index: 94;
  background: rgba(10, 10, 12, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.scrim-enter-active, .scrim-leave-active { transition: opacity 0.4s ease; }
.scrim-enter-from, .scrim-leave-to { opacity: 0; }

.overlay {
  position: fixed; top: clamp(16px, 2vw, 28px); right: clamp(16px, 2vw, 28px);
  z-index: 95;
  width: clamp(320px, 42vw, 620px);
  max-height: calc(100vh - clamp(32px, 4vw, 56px)); overflow: auto;
  background: var(--grey);
  border-radius: 18px;
  padding: clamp(28px, 3vw, 44px) clamp(28px, 3vw, 48px) clamp(28px, 3vw, 40px);
  display: flex; flex-direction: column;
  transform-origin: top right;
  box-shadow: -30px 40px 90px rgba(0, 0, 0, 0.35);
}
.close {
  align-self: flex-end;
  display: inline-flex; align-items: center; gap: 10px;
  margin-bottom: clamp(30px, 4vw, 56px);
  background: none; border: none; color: var(--ink); cursor: pointer;
  font-family: var(--font-mono); font-size: 13px; letter-spacing: 2px;
  transition: opacity 0.25s;
}
.close:hover { opacity: 0.6; }
.close svg { display: block; }
.over-nav { display: flex; flex-direction: column; }
.over-nav a {
  font-family: var(--font-display); font-weight: 600;
  font-size: clamp(32px, 3.6vw, 58px); letter-spacing: -2px;
  color: var(--ink); text-decoration: none; line-height: 1.08;
  transition: padding-left 0.35s var(--ease), opacity 0.3s;
}
.over-nav a sup {
  font-size: 0.32em; font-weight: 500; vertical-align: super;
  margin-left: 4px; letter-spacing: 0;
}
.over-nav a:hover { padding-left: 16px; opacity: 0.55; }
.over-foot {
  margin-top: clamp(36px, 4vw, 56px);
  display: flex; gap: 30px; flex-wrap: wrap;
  color: #5a5a60; font-size: 12px; letter-spacing: 1px;
}
.over-foot a { color: var(--ink); text-decoration: none; }
.over-foot a:hover { color: var(--coral); }

/* unfold down from the top-right corner */
.over-enter-active { transition: transform 0.5s var(--ease), opacity 0.35s ease; }
.over-leave-active { transition: transform 0.4s var(--ease), opacity 0.3s ease; }
.over-enter-from, .over-leave-to {
  opacity: 0;
  transform: scale(0.94) translateY(-12px);
}
.over-enter-to, .over-leave-from {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.over-nav a { will-change: padding-left; }

@media (max-width: 760px) {
  .hdr { padding: 16px clamp(16px, 4vw, 24px); }
  .logo { padding: 10px 18px; font-size: 18px; }
  .menu-btn { padding: 10px 16px 10px 14px; font-size: 12px; }
}
</style>
